import React, { Component } from "react";
import { TouchableOpacity, View, Dimensions } from "react-native";
import TextView from "./TextView";
import { componentStyles, appStyles } from "../theme/styles";
import {
  greenLightColor,
  greenDarkColor,
  yellowLightColor,
  yellowDarkColor,
} from "../theme/colors";
import LinearGradient from "react-native-linear-gradient";
import { persianNumber } from "../utils/utils";
import { wp } from "../utils/responsive";
let { width } = Dimensions.get("window");
class RequestItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <View style={componentStyles.requestItemWraper}>
        <View style={appStyles.rowBetween}>
          <LinearGradient
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
            colors={[yellowLightColor, yellowDarkColor]}
            style={[
              { width: 70, height: 70, borderRadius: 20 },
              appStyles.center,
            ]}
          >
            <TextView
              isbold={true}
              style={[{ textAlign: "center", fontSize: 20, color: "white" }]}
            >
              {persianNumber(this.props.data.distance)}
            </TextView>
            <TextView
              style={[{ textAlign: "center", fontSize: 12, color: "white" }]}
            >
              کیلومتر تا مقصد
            </TextView>
          </LinearGradient>
          <View>
            <TextView style={{ maxWidth: width - 140, textAlign: "right" }}>
              نوع خدمت : {this.props.data.title_service}
            </TextView>
            <TextView
              style={{
                color: "grey",
                fontSize: 12,
                textAlign: "right",
                marginTop: 10,
              }}
            >
              سفارش دهنده : {this.props.data.sick_name}
            </TextView>
          </View>
        </View>
        <TextView style={{ textAlign: "right", margin: 10 }}>
          {this.props.data.address}
        </TextView>
        <View style={appStyles.rowBetween}>
          <TouchableOpacity
            onPress={() => {
              this.props.onAgree();
            }}
          >
            <LinearGradient
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 0 }}
              colors={[greenLightColor, greenDarkColor]}
              style={[
                componentStyles.gradinatButton,
                { borderRadius: 20, height: 40, width: width / 5 },
              ]}
            >
              <TextView
                isbold={true}
                style={[{ textAlign: "center", color: "white" }]}
              >
                قبول میکنم
              </TextView>
            </LinearGradient>
          </TouchableOpacity>
          <TouchableOpacity
            style={[
              appStyles.outlineButton,
              { height: 40, borderRadius: 20, width: width / 5 },
            ]}
            onPress={() => {
              this.props.onDisagree();
            }}
          >
            <TextView style={{ color: "#C5C5C5" }}>لغو سفارش</TextView>
          </TouchableOpacity>
        </View>
      </View>
    );
  }
}

export default RequestItem;
